import { jwtDecode as jwt_decode } from 'jwt-decode';

// utils/auth.js

export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  const tokenExpiry = localStorage.getItem("tokenExpiry");
  
  if (!token || !tokenExpiry) {
    return false;
  }
  
  // Check if token has expired
  if (Date.now() > parseInt(tokenExpiry)) {
    // Token expired, clear everything
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiry");
    localStorage.removeItem("role");
    localStorage.removeItem("userData");
    return false;
  }
  
  return true;
};

export const getUserRole = () => {
  return localStorage.getItem("role"); // Returns "ROLE_ADMIN" or "ROLE_USER"
};

export const isAdmin = () => {
  return getUserRole() === "ROLE_ADMIN";
};

export const isUser = () => {
  return getUserRole() === "ROLE_USER";
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenExpiry");
  localStorage.removeItem("role");
  localStorage.removeItem("userData");
  localStorage.removeItem("username");
  localStorage.removeItem("email");
  localStorage.removeItem("loginId");
  window.location.href = "/";
};